export const REJECT_RESERVE_REQUEST = 'REJECT_RESERVE_REQUEST';
export const REJECT_RESERVE_SUCCESS = 'REJECT_RESERVE_SUCCESS';
export const REJECT_RESERVE_ERROR = 'REJECT_RESERVE_ERROR';
